<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 新闻资讯</div>
        <div class="title-nav">
          <div class="nav-li" v-for="(item, index) in navItems" :key="index" :class="{ active: activeIndex === item.id }" @click="setActive(item.id)">
            {{ item.name }}
          </div>
        </div>
        <information v-if="nationList.length > 0" :information="nationList" :page="page" @sizeChange="sizeChange" @currentChange="currentChange" />
        <empty class="empty-margin" v-if="nationList.length <= 0"></empty>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import information from "@/components/information/index";
import { getPageList, getInformationType } from '@/api/home'
import empty from "@/components/empty/index";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, information, empty },
  data() {
    return {
      selectedIndex: 2,
      navItems: [],
      activeIndex: '',
      nationList: [],
      page: {
        number: 1,
        limit: 10,
        total: 0,
      },
      searchTitle: '',
    }
  },
  watch: {
    "$route" (to, from) {
      this.searchTitle = to.query.title ? to.query.title : ''
      this.page.number = 1
      this.getPageList()
    },
  },
  methods: {
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的项
      this.getPageList()
    },
    // 列表查询资讯类型
    async getInformationType() {
      await getInformationType({
        categories: 'NEWS',
      }).then(res => {
        this.navItems = res.data
        this.activeIndex = res.data.length > 0 ? res.data[0].id : ''
      })
    },
    // 分页查询新闻资讯、质控课程、质控公告、指南共识
    async getPageList() {
      await getPageList({
        number: 1,
        limit: 6,
        checkStatus: 'HAVE_RELEASED',
        categories: 'NEWS',
        type: this.activeIndex,
        title: this.searchTitle,
      }).then(res => {
        this.nationList = res.data
        this.page.total = res.totalCount
      })
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getPageList()
    },
    currentChange(value) {
      this.page.number = value
      this.getPageList()
    },
  },
  async mounted() {
    if (this.$route.query.title) {
      this.searchTitle = this.$route.query.title
    }
    await this.getInformationType()
    await this.getPageList()
  }
}
</script>

<style lang="less" scoped>
.center-box {
  padding-bottom: 80px;
}

/deep/.el-input__inner {
  // height: 32px;
  // border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  // color: rgba(0, 0, 0, 0.45) !important;
  // line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Information/index.vue